@use "ui/buttons/buttonStyles" as buttonStyles;

// Icon-only Button-shaped primitive. Layout differs from .wrapper (square
// footprint via aspect-ratio + box-sizing), but variant colors are shared with
// Button via the mixins in _buttonStyles.scss.
.iconButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  transition: all 0.2s;
  cursor: pointer;
  aspect-ratio: 1;
  // Width must match height so aspect-ratio holds with content of varying intrinsic
  // size (LoadingDots is wider than tall). box-sizing: border-box ensures padding +
  // border are inside the square footprint.
  box-sizing: border-box;
  flex-shrink: 0;

  @include buttonStyles.focus-ring;

  &:disabled {
    cursor: not-allowed;
  }

  // Icons inside scale with the button's font-size — consumers don't need to pass
  // an explicit size. Mirrors the .iconButton convention in EditFormHeader.module.scss.
  svg {
    width: 1em;
    height: 1em;
  }

  // Keep the LoadingDots indicator a flex box so its three dots center
  // horizontally and vertically inside the square footprint.
  &.pending > * {
    display: inline-flex;
    align-items: center;
    line-height: 0;
  }
}

// Variants shared with Button — see packages/ui/buttons/_buttonStyles.scss
.primary {
  @include buttonStyles.variant-primary;
}

.secondary {
  @include buttonStyles.variant-secondary;
}

.tertiary {
  @include buttonStyles.variant-tertiary;
}

.quaternary {
  @include buttonStyles.variant-quaternary;
}

.progress {
  @include buttonStyles.variant-progress;
}

.completed {
  @include buttonStyles.variant-completed;
}

.white {
  @include buttonStyles.variant-white;
}

.black {
  @include buttonStyles.variant-black;
}

.noStyle {
  @include buttonStyles.variant-noStyle;
}

// Sizes: explicit width keeps each size distinct regardless of icon intrinsic size.
// Each size also defines a font-size that the inner svg picks up via `1em` so icons
// scale automatically (~55–60% of the button footprint).
.jumbo {
  border-radius: 6px;
  width: 52px;
  height: 52px;
  font-size: 28px;
}

.large {
  border-radius: 4px;
  width: 40px;
  height: 40px;
  font-size: 22px;
}

.medium {
  border-radius: 4px;
  width: 32px;
  height: 32px;
  font-size: 18px;
}

.small {
  border-radius: 3px;
  width: 24px;
  height: 24px;
  font-size: 14px;
}

.xsmall {
  border-radius: 3px;
  width: 20px;
  height: 20px;
  font-size: 12px;
}
